import React from 'react';

const LoadingPage = ({ classes }) => {
  return <div className={classes.loading}>Loading Questionnaire</div>;
};

export default LoadingPage;
